import {Component, OnInit} from '@angular/core';
import {MenuItem, MessageService} from 'primeng/api';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {ShipmentInstructionService} from '../../@shared/new-services/shipment-instruction.service';
import {ActivatedRoute} from '@angular/router';
import {UserMgmtService} from '../../@shared/new-services/user-mgmt.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-preview-si',
    templateUrl: './preview-si.component.html',
    styleUrls: ['./preview-si.component.scss']
})
export class PreviewSiComponent implements OnInit {

    home: MenuItem = {icon: 'pi pi-home', routerLink: '/booking-summary'};
    breadcrumbMenuModel: MenuItem[] = [];

    // Main SI Variables
    bookingId: string;
    shipmentType: string;
    shipmentInstruction: any;
    shipmentInstructionForm: FormGroup;

    // UserContacts
    shipperContacts: any[] = [];
    consigneeContacts: any[] = [];
    firstNotifyPartyContacts: any[] = [];
    secondNotifyPartyContacts: any[] = [];
    contactFormAction: string;
    countries: any;

    isLoading = false;
    isDownloadingFile = false;

    constructor(private shipmentInstructionService: ShipmentInstructionService,
                private activatedRoute: ActivatedRoute,
                private messageService: MessageService,
                private userMgmtService: UserMgmtService) {
    }

    ngOnInit() {
        this.activatedRoute
            .queryParams.subscribe((param) => {
            this.bookingId = param?.bookingId;
            this.shipmentType = param?.shipmentType;
        });
        this.getShipmentInstruction(this.bookingId); // GET SI by BookingId
        this.createShipmentInstructionForm(); // Create New SI Form
        this.getCountries();
    }

    getShipmentInstruction(bookingId?: string) {
        this.isLoading = true;
        this.shipmentInstructionService
            .getShipmentInstructionsByBookingId(bookingId)
            .subscribe((shipmentInstruction) => {
                this.shipmentInstruction = shipmentInstruction;
                this.breadcrumbMenuModel = [
                    {label: 'Booking Summary', routerLink: '/booking-summary'},
                    {label: 'Shipping Instruction : ' + shipmentInstruction?.bookingId}
                ];
                this.createShipmentInstructionForm(shipmentInstruction); // Creating Form with Data from API
                this.getCountries(); // For UserContact Management GET Countries
                this.isLoading = false;
                this.getUserContacts(); // GET UserContacts
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
                this.isLoading = false;
            });
    }

    getCountries() {
        this.shipmentInstructionService.getCountries()
            .subscribe((countries) => {
                this.countries = countries;
            }, error => {
                this.presentToastMessage('error', error?.message ? error?.message : error);

            });
    }

    getUserContacts() {
        this.shipperContacts = [];
        this.consigneeContacts = [];
        this.firstNotifyPartyContacts = [];
        this.secondNotifyPartyContacts = [];
        if (this.shipmentInstruction?.shipper) {
            this.shipperContacts.push(this.shipmentInstruction?.shipper);
        }
        if (this.shipmentInstruction?.consignee) {
            this.consigneeContacts.push(this.shipmentInstruction?.consignee);
        }
        if (this.shipmentInstruction?.firstNotifyParty) {
            this.firstNotifyPartyContacts.push(this.shipmentInstruction?.firstNotifyParty);
        }
        if (this.shipmentInstruction?.secondNotifyParty) {
            this.secondNotifyPartyContacts.push(this.shipmentInstruction?.secondNotifyParty);
        }
        this.userMgmtService
            .getUserContacts('SHIP_FROM_SHIP_TO')
            .subscribe((userContacts) => {
                userContacts?.map((x) => {
                    this.shipperContacts?.push(x);
                    this.consigneeContacts?.push(x);
                    this.firstNotifyPartyContacts?.push(x);
                    this.secondNotifyPartyContacts?.push(x);
                });
                // tslint:disable-next-line:no-shadowed-variable
            }, (error) => {

                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    presentToastMessage(severity, detail) {
        this.messageService
            .add(
                {
                    severity,
                    summary: 'Shipment Instruction Message',
                    key: 'shipment-instruction-message',
                    detail,
                }
            );
    }

    createShipmentInstructionForm(shipmentInstruction?: any) {
        this.shipmentInstructionForm = new FormGroup({

            // Required Backend Fields
            bookingId: new FormControl(shipmentInstruction?.bookingId ? shipmentInstruction?.bookingId : ''),
            domainName: new FormControl(shipmentInstruction?.domainName ? shipmentInstruction?.domainName : ''),
            siId: new FormControl(shipmentInstruction?.siId ? shipmentInstruction?.siId : ''),
            shipmentType: new FormControl(shipmentInstruction?.shipmentType ? shipmentInstruction?.shipmentType : this.shipmentType),

            // Shipment Details
            placeOfReceipt: new FormControl(shipmentInstruction?.placeOfReceipt ? shipmentInstruction?.placeOfReceipt : ''),
            placeOfReceiptEditable: new FormControl(shipmentInstruction?.placeOfReceiptEditable ?
                shipmentInstruction?.placeOfReceiptEditable : ''),
            portOfLoading: new FormControl(shipmentInstruction?.portOfLoading ? shipmentInstruction?.portOfLoading : ''),
            portOfLoadEditable: new FormControl(shipmentInstruction?.portOfLoadEditable ? shipmentInstruction?.portOfLoadEditable : ''),
            portOfDischarge: new FormControl(shipmentInstruction?.portOfDischarge ? shipmentInstruction?.portOfDischarge : ''),
            portOfDischargeEditable: new FormControl(shipmentInstruction?.portOfDischargeEditable ?
                shipmentInstruction?.portOfDischargeEditable : ''),
            finalPlaceOfDelivery: new FormControl(shipmentInstruction?.finalPlaceOfDelivery ?
                shipmentInstruction?.finalPlaceOfDelivery : ''),
            finalPlaceOfDeliveryEditable: new FormControl(shipmentInstruction?.finalPlaceOfDeliveryEditable ?
                shipmentInstruction?.finalPlaceOfDeliveryEditable : ''),

            // Party Details
            shipper: new FormControl(shipmentInstruction?.shipper ?
                shipmentInstruction?.shipper : null),
            consignee: new FormControl(shipmentInstruction?.consignee ?
                shipmentInstruction?.consignee : null),
            firstNotifyParty: new FormControl(shipmentInstruction?.firstNotifyParty ?
                shipmentInstruction?.firstNotifyParty : null),
            secondNotifyParty: new FormControl(shipmentInstruction?.secondNotifyParty ?
                shipmentInstruction?.secondNotifyParty : null),

            // Cargo Description
            cargoDescription: new FormControl(shipmentInstruction?.cargoDescription ?
                shipmentInstruction?.cargoDescription : ''),
            cargoDescriptionAddon: new FormControl(shipmentInstruction?.cargoDescriptionAddon ?
                shipmentInstruction?.cargoDescriptionAddon : ''),

            // Marks & Numbers
            isMarksAndNumber: new FormControl(!!shipmentInstruction?.isMarksAndNumber),
            marksAndNumber: new FormControl(shipmentInstruction?.marksAndNumber ? shipmentInstruction?.marksAndNumber : ''),

            // Freight Payment Terms
            freightTerm: new FormControl(shipmentInstruction?.freightTerm ? shipmentInstruction?.freightTerm : 'prepaid'),

            // Special Instructions
            specialInstruction: new FormControl(shipmentInstruction?.specialInstruction ? shipmentInstruction?.specialInstruction : ''),

            // Special Handling Instructions
            specialHandlingInstruction: new FormControl(shipmentInstruction?.specialHandlingInstruction
                ? shipmentInstruction?.specialHandlingInstruction : ''),

            // L/C Shipment
            isLcShipment: new FormControl(!!shipmentInstruction?.isLcShipment),
            lcNotes: new FormControl(shipmentInstruction?.lcNotes ? shipmentInstruction?.lcNotes : ''),
            lcDocument: new FormControl(shipmentInstruction?.lcDocument ? shipmentInstruction?.lcDocument : null),

            // Is Original Doc
            isOriginalDocument: new FormControl(shipmentInstruction?.isOriginalDocument ? this.shipmentType !== 'AIR' ?
                null : true : shipmentInstruction?.isOriginalDocument),

            // Container / Cargo Details
            siContainers: new FormArray([]),

            // SI Documents
            siDocuments: new FormControl(shipmentInstruction?.siDocuments ? shipmentInstruction?.siDocuments : []),

            // Customer Reference Number
            customerReferenceNumber: new FormControl(shipmentInstruction?.customerReferenceNumber
                ? shipmentInstruction?.customerReferenceNumber : '')
        });
    }

    generateSIPreviewPDF(htmlElement) {
        this.isDownloadingFile = true;

        const htmlTag = document.getElementById(htmlElement);
        html2canvas(htmlElement).then((canvas) => {
            const contentToDataUrl = canvas.toDataURL('image/jpeg', 1.0);
            // const fileWidth = 208;
            // const fileHeight = canvas.height * fileWidth / canvas.width;
            // const width = doc.internal.pageSize.getWidth() - 3;
            // const height = doc.internal.pageSize.getHeight() - 50;

            const imgWidth = 207;
            const pageHeight = 295;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            let heightLeft = imgHeight;
            const doc = new jsPDF.default('p', 'mm', 'a4');
            let position = 10; // give some top padding to first page

            doc.addImage(contentToDataUrl, 'PNG', 3, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position += heightLeft - imgHeight; // top padding for other pages
                doc.addPage();
                doc.addImage(contentToDataUrl, 'PNG', 3, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            doc.setFontSize(10);
            // doc.addImage(contentToDataUrl, 'PNG', 3, 3, imgWidth, imgHeight);
            // doc.text('Shipping Instructions - ' + this.bookingId, 60, 4);
            // doc.addImage(contentToDataUrl, 'jpeg', 3, 10, fileWidth, fileHeight);
            doc.save('si-preview.pdf');
            this.isDownloadingFile = false;
        });
    }

    getDocumentByDocumentTypeId(siPayload: any, documentTypeId: string): any {
        const containerDocument: Observable<any> = siPayload?.siDocuments?.map((document) => {
            if (document?.documentTypeId === documentTypeId) {
                document.name = document?.name ? document?.name : 'File Name is Empty';
                return document as Observable<any>;
            }
        });
        return containerDocument[0];
    }

}
